import React, { useRef, useState, useEffect, useContext } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { conversationState, responseErrorState, tableLoadingState, numeroActiveState, isSearchUploadedFilesState  } from "../../store/atoms";
//import { Amplify } from 'aws-amplify';
import SendIcon from '@mui/icons-material/Send';
import axios from "axios";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { MyContext } from "../../Context/MyContext";
import { logEvent } from '../../cloudwatchLogger';
import {MoveUpRight} from 'lucide-react';
import useLambda from '../hooks/useLambda';
import { awsExports } from '../../aws-exports';
import AWS from 'aws-sdk';
import Sparkles from "./Sparkles";
import { getCurrentUser, fetchUserAttributes, updateUserAttributes } from 'aws-amplify/auth';
import {jwtTokenState} from '../../store/atoms';
//Amplify.configure(awsExports);
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useMediaQuery } from '@mui/material';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { firstNameState, displayRoleState, selectedTeamState } from "../../store/atoms";

import {
  conversationIdState,
  numeroActiveStatesetError
} from '../../store/atoms';

const invokeLambda = async (action, payload, lambda, lambdaFunctionName) => {
  //console.log('action is : '+action);
  const params = {
    FunctionName: lambdaFunctionName,
    InvocationType: 'RequestResponse',
    Payload: JSON.stringify({ action, payload })
  };

  try {
    const response = await lambda.invoke(params).promise();
    const result = JSON.parse(response.Payload);
    //console.log('result from the lambda is: '+JSON.stringify(result.data));
    if (!result.success) throw new Error(result.error);
    return result.data;
  } catch (error) {
    console.error(`Error invoking Lambda (${action}):`, error);
    throw error;
  }
};



const DropdownItem = ({ text, onClick }) => (
  <div 
    className="w-full hover:bg-gray-100 cursor-pointer rounded-md transition-colors duration-200"
    onClick={onClick}
  >
    <div className="flex items-center p-3">
      <MoveUpRight className="w-4 h-4 mr-3 text-gray-600" />
      <span className="text-sm font-inter">{text}</span>
    </div>
    {/* <button onClick={(e) => { e.stopPropagation(); onRemove(); }} className="text-yellow-500 hover:text-yellow-700">
      Remove
    </button> */}
  </div>
);

const PromptBar = ({ selectedQuery }) => {
  const [selectedManagedQuery, setSelectedManagedQuery] = useState('');
  const [conversation, setConversation] = useRecoilState(conversationState);
  const [conversationId, setConversationId] = useRecoilState(conversationIdState);
  const [tableLoading, setTableLoading] = useRecoilState(tableLoadingState)
  //console.log('conversation in prompt bar: '+conversation.length);
  const [inputQuestion, setInputQuestion] = useState('');
  const [numeroActive, setNumeroActive] = useRecoilState(numeroActiveState);
  const [isHovered, setIsHovered] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [localTranscript, setLocalTranscript] = useState("");
  const [isInputFocused, setIsInputFocused] = useState(false);
  const inputRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const { value, setValue, isDarkTheme } = useContext(MyContext);
  const [error, setError] = useState(null);
  //const [logEvents, setLogEvents] = useRecoilState(logEventsState);
  const [firstName, setFirstName] = useState("");
  const {configureLambda, decodeToken,getJWT } = useLambda();
  const [responseError, setResponseError] = useRecoilState(responseErrorState);
  const [s3File, setS3File] = useState('');
  // const [apiUrl, setApiUrl] = useState('');

  // const [lambdaFunctionName] = useState(awsExports.Lambda.text2sql);
  const [lambdaFunctionName, setLambdaFunctionName] = useState(awsExports.Lambda.text2sql);

  const isMobile = useMediaQuery('(max-width:768px)');

  const [managedQueries, setManagedQueries] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  const [isSearchUploadedFiles, setIsSearchUploadedFiles] = useRecoilState(isSearchUploadedFilesState);
  const [showFileDropdown, setShowFileDropdown] = useState(false);
  // const [selectedFile, setSelectedFile] = useState(s3File);
  const [fileList, setFileList] = useState([]);
  const [showAllFiles, setShowAllFiles] = useState(false);
  const textareaRef = useRef(null);
  const [selectedTeam, setSelectedTeam] = useRecoilState(selectedTeamState);

  const [selectedFile, setSelectedFile] = useState(() => {
    return localStorage.getItem('selectedFile') || '';
  });

  useEffect(() => {
    if (selectedFile) {
      localStorage.setItem('selectedFile', selectedFile);
    }
  }, [selectedFile]);

  const toggleSearchUploadedFiles = () => {
    const newState = !isSearchUploadedFiles;
    setIsSearchUploadedFiles(newState);

    if (!newState) {
      setSelectedFile('');
      localStorage.removeItem('selectedFile');
    }
  };

  // console.log('is search uploaded files is: '+isSearchUploadedFiles);
  //console.log('table loading state is: '+ tableLoading);

  useEffect(() => {
    if (isSearchUploadedFiles && selectedTeam?.name) {
      // Reset file selection when team changes
      setSelectedFile('');
      localStorage.removeItem('selectedFile');
      setFileList([]); // Clear the existing file list
      fetchFilesFromS3(); // Fetch new files for the new team
    }
  }, [selectedTeam, isSearchUploadedFiles]);

  useEffect(() => {
    let interval;
    if (isLoading) {
      interval = setInterval(() => {
        setActiveIndex(prev => (prev === 0 ? 1 : 0));
      }, 500);
    }
    return () => clearInterval(interval);
  }, [isLoading]);

  const fetchFilesFromS3 = async () => {
    try {
      if (!selectedTeam?.name) return;
  
      const s3 = new AWS.S3({
        accessKeyId: awsExports.S3.accessKeyId,
        secretAccessKey: awsExports.S3.secretAccessKey,
        region: awsExports.S3.region,
      });
  
      const folderPath = `Tenants/${selectedTeam.name}/ClientCreate/`;
      const params = {
        Bucket: awsExports.S3.bucket,
        Prefix: folderPath,
      };
  
      const data = await s3.listObjectsV2(params).promise();
      const files = data.Contents
        .filter(file => !file.Key.endsWith('/'))
        .map(file => file.Key.replace(folderPath, ''));
  
      setFileList(files);
      
      // Don't automatically select any file - just update the list
      // The placeholder will remain "Select a file" until user chooses one
    } catch (error) {
      console.error('Error fetching files from S3:', error);
    }
  };

    

  useEffect(() => {
    if (isSearchUploadedFiles && selectedTeam?.name) {
      fetchFilesFromS3();
    }
  }, [selectedTeam, isSearchUploadedFiles]);


  useEffect(() => {
    const fetchUserName = async () => {
      try {
        const userAttributes = await fetchUserAttributes();
        //console.log(`user atttributes are: ${JSON.stringify(userAttributes)}`);
        setFirstName(userAttributes.given_name);
      } catch (error) {
        console.error('Failed to fetch roles:', error);
      }
    };
  
    fetchUserName();
  }, []);


  // useEffect(() => {
  //   if(isSearchUploadedFiles){
  //     setApiUrl(awsExports.API.fileSearchAPI);
  //   }else{
  //     setApiUrl(numeroActive ? awsExports.API.numeroAPI : awsExports.API.text2sqlAPI);
  //   }
  // }, [isSearchUploadedFiles, numeroActive]);
   
  useEffect(() => {
    if (isSearchUploadedFiles) {
      // console.log('Setting lambda to donorCompare because isSearchUploadedFiles is true');
      setLambdaFunctionName(awsExports.Lambda.donorCompare);
    } else {
      // console.log(`Setting lambda to ${numeroActive ? 'numeroAPI' : 'text2sql'} because isSearchUploadedFiles is false`);
      setLambdaFunctionName(numeroActive ? awsExports.Lambda.numeroAPI : awsExports.Lambda.text2sql);
    }
  }, [isSearchUploadedFiles, numeroActive]);

  useEffect(() => {
    // console.log('Current lambdaFunctionName:', lambdaFunctionName);
  }, [lambdaFunctionName]);

 // const apiUrl = numeroActive ? awsExports.API.numeroAPI : awsExports.API.text2sqlAPI;
   //console.log('api url is: '+apiUrl);
  const updateUserActivity = async (queryText) => {
    try {
        const attributes = await fetchUserAttributes();
        
        // Get current date and existing query count
        const today = new Date().toISOString().split('T')[0];
        // Handle null/undefined cases
        const lastQueryDate = attributes['custom:lastQueryDate'] || '';
        const queryCount = attributes['custom:dailyQueryCount'];
        
        // Calculate new query count
        let newQueryCount = 1;
        if (lastQueryDate === today) {
          // Use 0 as fallback if queryCount is null/undefined or not a valid number
          newQueryCount = parseInt(queryCount || '0', 10) + 1;
        }
        // Update user attributes
        await updateUserAttributes({
          userAttributes: {
            'custom:lastQuery': queryText,
            'custom:lastQueryTime': Date.now().toString(),
            'custom:lastQueryDate': today,
            'custom:dailyQueryCount': newQueryCount.toString()
          }
        });
    } catch (error) {
        console.error('Error updating user attributes:', error);
    }
};

  const handleInputChange = (e) => {
    setInputQuestion(e.target.value);
    setError(null); // Clear error on new input
  };

  const handleQueryClick = (query) => {
    setSelectedManagedQuery(query);
    logEvent({ eventType: 'querySelected', details: `Selected query: ${query}` });
  };

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const s3 = new AWS.S3({
          accessKeyId: awsExports.S3.accessKeyId,
          secretAccessKey: awsExports.S3.secretAccessKey,
          region: awsExports.S3.region,
        });
        const tenantGroup = selectedTeam.name;
        const folderPath = `Tenants/${tenantGroup}/ClientCreate/`;
        const params = {
          Bucket: awsExports.S3.bucket,
          Prefix: folderPath,
        };

        const data = await s3.listObjectsV2(params).promise();
        const files = data.Contents
          .filter(file => !file.Key.endsWith('/'))
          .map(file => file.Key.replace(folderPath, ''));

        setFileList(files);
      } catch (error) {
        console.error('Error fetching files from S3:', error);
      }
    };

    if (selectedTeam.length > 0) {
      fetchFiles();
    }
  }, [selectedTeam]);

  

  const generateAnswer = async (prompt, selectedFile) => {
  //   console.log('Starting generateAnswer with lambda:', lambdaFunctionName);
  // console.log('Prompt:', prompt);
  // console.log('Selected file:', selectedFile);

    const tokenJWT = await getJWT();
    // console.log('token is: '+tokenJWT);

    const lambda = new AWS.Lambda();
    
    // Remove the file extension from the selectedFile
    const filenameWithoutExtension = selectedFile ? selectedFile.replace(/\.[^/.]+$/, '') : '';
    const tenantGroup = selectedTeam.name;
    const payload = {
      user_prompt: prompt,
      token: tokenJWT,
      conversation_id: conversationId,
      filename: filenameWithoutExtension,
      selected_group: tenantGroup,
      // isSearchUploadedFiles: isSearchUploadedFiles,
      // numeroActive: numeroActive
    };

    // console.log('Payload for lambda:', payload);

    try {
      const params = {
        FunctionName: lambdaFunctionName,
        InvocationType: 'RequestResponse',
        Payload: JSON.stringify(payload)
      };

      // console.log('Lambda invoke params:', params);

      // console.log(`Invoking lambda: ${lambdaFunctionName}...`);

      const response = await lambda.invoke(params).promise();
      const result = JSON.parse(response.Payload);
      // console.log('result from the lambda is: '+JSON.stringify(result));
      // console.log('Parsed lambda result:', result);
      // if (!result.success) {
      //   throw new Error(result.error || 'Failed to generate answer');
      // }

      const answer = result;
      const parsedRes = JSON.parse(answer.body);
      setConversationId(parsedRes.conversation_id);
      setError(null);
      return answer;
    } catch (error) {
      if (error.code === 'ECONNABORTED') {
        setError('The request took too long to complete. Please try again.');
        setResponseError('The request took too long to complete. Please try again.');
      } else {
        setResponseError(error.message || 'Request is missing key information needed to process accurate results. Please clarify or rephrase and try again.');
        setError(error.message || 'An unexpected error occurred.');
      }
      throw error;
    }
  };

 
  // Handle file selection
  const handleFileSelect = (file) => {
    setSelectedFile(file);
    setShowFileDropdown(false);
  };

  const handleSend = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation(); // Add this to prevent event bubbling
    }
    
    if (isSearchUploadedFiles && !selectedFile) {
      // console.log('Error: No file selected when isSearchUploadedFiles is true');
      setError('Please select a file from the dropdown.');
      return;
    }
  
    const userPrompt = inputQuestion || value;

    // console.log('Sending prompt:', userPrompt);
    // console.log('Current lambda function:', lambdaFunctionName);
    // console.log('isSearchUploadedFiles:', isSearchUploadedFiles);
    // console.log('selectedFile:', selectedFile);

    setValue("");
    setIsLoading(true);
    setLocalTranscript(userPrompt);
    logEvent({ action: 'UserInput', message: userPrompt, type: 'input' });
  
    try {
      await updateUserActivity(userPrompt);
      const answer = await generateAnswer(userPrompt, selectedFile);
      const newConversation = {
        id: new Date().getTime(),
        date: new Date(),
        question: userPrompt,
        response: answer,
      };
      setConversation([newConversation, ...conversation]);
      setInputQuestion("");
      logEvent({ action: 'AIResponse', message: 'AI response generated', type: 'response' });
    } catch (error) {
      console.error("Error:", error);
      logEvent({ action: 'Error', message: 'Failed to generate AI response', type: 'error' });
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation(); // Prevents the default action of the Enter key (e.g., form submission)
      if (!isLoading) {
        handleSend();
      }
    }
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading && conversation.length === 0) {
      setTableLoading(true); //navigate('/sparkles');
    } else if (conversation.length > 0) {
      setTableLoading(false);
      navigate('/targetPage');
    }
  }, [isLoading, conversation, navigate]);

  const handleClear = () => {
    setInputQuestion("");
  };

  useEffect(() => {
    if (selectedQuery) {
      setInputQuestion(selectedQuery);
    }
  }, [selectedQuery]);

  useEffect(() => {
    if (value) {
      setInputQuestion(value);
    }
  }, [value]);

  useEffect(() => {
    if (selectedManagedQuery) {
      setInputQuestion(selectedManagedQuery);
    }
  }, [selectedManagedQuery]);

  const handleDropdownItemClick = (item) => {
    setInputQuestion(item);
    setShowDropdown(false);
    inputRef.current.focus();
  };

  const handleRemoveItem = (item) => {
    // Implement remove logic here
    // console.log('Removing:', item);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && !inputRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // const promptBarBackgroundColor = inputQuestion ? 'bg-white' : 'bg-zinc-100';

  

  const buttonClass = `
    w-full min-w-[120px] h-[40px] min-h-[40px] rounded-2xl 
    bg-[#f1b20b] text-center p-2 text-[#ffffff] font-bold mb-2
    whitespace-nowrap overflow-hidden text-ellipsis
  `;

  const LogoSVG = ({ isActive }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M11.7891 21.8977C17.3119 21.8977 21.7891 17.4206 21.7891 11.8977C21.7891 6.37486 17.3119 1.89771 11.7891 1.89771C6.26621 1.89771 1.78906 6.37486 1.78906 11.8977C1.78906 17.4206 6.26621 21.8977 11.7891 21.8977Z" stroke={isActive ? "white" : "black"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M11.7891 15.8977C13.9982 15.8977 15.7891 14.1068 15.7891 11.8977C15.7891 9.68857 13.9982 7.89771 11.7891 7.89771C9.57992 7.89771 7.78906 9.68857 7.78906 11.8977C7.78906 14.1068 9.57992 15.8977 11.7891 15.8977Z" stroke={isActive ? "white" : "black"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.71875 4.82764L8.95875 9.06764" stroke={isActive ? "white" : "black"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14.6191 14.7278L18.8591 18.9678" stroke={isActive ? "white" : "black"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14.6191 9.0676L18.1491 5.5376" stroke={isActive ? "white" : "black"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.71875 18.9678L8.95875 14.7278" stroke={isActive ? "white" : "black"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
  
  

  useEffect(() => {
    if (textareaRef.current) {
      adjustTextareaHeight();
    }
  }, [inputQuestion]);

  const adjustTextareaHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      // Reset height to get the correct scrollHeight
      textarea.style.height = 'auto';
      // Calculate new height while respecting line breaks
      const newHeight = Math.min(textarea.scrollHeight, 200); // Max height 200px
      textarea.style.height = `${newHeight}px`;
    }
  };

  const handleTextareaChange = (e) => {
    handleInputChange(e);
    adjustTextareaHeight();
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if dropdownRef.current exists before accessing its properties
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowFileDropdown(false);
      }
    };
  
    // Attach the event listener
    document.addEventListener('mousedown', handleClickOutside);
  
    // Clean up the event listener on unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []); // Empty dependency array ensures this runs only once

  const formatFileName = (fileName) => {
    // Remove file extension
    const nameWithoutExtension = fileName.replace(/\.[^/.]+$/, '');
    // Remove underscores and split into parts
    const parts = nameWithoutExtension.split('_');
    // Remove date-time parts (assuming they are at the end)
    const meaningfulParts = parts.filter(part => !/\d{8}T\d{6}Z/.test(part));
    // Join the meaningful parts with spaces
    return meaningfulParts.join(' ');
  }; 


  return (
    <div className="flex flex-col self-stretch">
      {/* Prompt Bar */}
      <form onSubmit={handleSend} className="flex min-h-[4.8125rem] px-[1.6875rem] py-6 justify-between items-center self-stretch rounded-[1.875rem] border border-[#D9D9D9] bg-white shadow-[10px_10px_20px_0px_#EAEAEA,_-10px_-10px_16px_0px_#FFF]">
        <textarea
          ref={textareaRef}
          id="searchQuery"
          value={inputQuestion}
          onChange={handleTextareaChange}
          onKeyDown={handleKeyDown}
          rows={1}
          className={`${
            isLoading
              ? 'bg-gradient-to-r from-[#EBAE12] via-[#40C5AF] to-[#EBAE12] bg-[length:200%_auto] animate-slowflow text-transparent bg-clip-text'
              : 'text-black'
          } font-inter text-[20px] font-bold leading-[1.5rem] w-full resize-none
          min-h-[29px] max-h-none
          placeholder-[#C2C2C2] focus:outline-none focus:ring-0 caret-black
          scrollbar-thin scrollbar-thumb-zinc-300 scrollbar-track-transparent`}
          placeholder="Type your query here"
          aria-label="Search query input"
          style={{
            overflowY: 'hidden',
            overflowX: 'hidden',
            whiteSpace: 'pre-wrap',
            wordWrap: 'break-word',
            height: 'auto'
          }}/>
        <div className="flex-shrink-0 flex items-center ml-4">
          {isLoading ? (
            <div className="p-2">
              <img
                src="/magic-wand-gif.gif"
                alt="Loading"
                className="w-full h-full"
              />
            </div>
          ) : (
            <button
              type="submit"
              aria-label="Submit search"
              className="p-2 transition-colors duration-200 cursor-pointer h-[2.5rem] flex items-center justify-center"
              //onClick={handleSend}
            >
              <img
                src={inputQuestion ? "/magic-wand-send2.svg" : "/magic-wand-01.svg"}
                alt="Send"
                className="w-full h-full"
              />
            </button>
          )}
        </div>
      </form>
  
      {/* Container for Dropdown and Toggle */}
      <div className="flex justify-end items-center mt-2">
        {/* Dropdown - Conditionally Rendered on the Left Side of the Toggle */}
        {isSearchUploadedFiles && (
          <div className="relative w-[30%] mr-2"> {/* Dropdown width and margin */}
            <button
              onClick={() => setShowFileDropdown(!showFileDropdown)}
              className="flex items-center justify-between w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-[1.875rem] shadow-[10px_10px_20px_0px_#EAEAEA,_-10px_-10px_16px_0px_#FFF] hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#EBAE12]"
            >
              {selectedFile
                ? selectedFile
                    .replace(/_/g, ' ') // Replace underscores with spaces
                    .replace(/\d{8}T\d{6}Z/, '') // Remove date-time part
                    .replace(/\.[^/.]+$/, '') // Remove file extension
                : "Select a file"}
              <ChevronDown className="w-5 h-5 ml-2 -mr-1 text-[#EBAE12]" />
            </button>
  
            {showFileDropdown && (
  <div className="absolute left-0 z-10 w-full mt-2 origin-top-left bg-white border border-gray-200 rounded-[1.875rem] shadow-[10px_10px_20px_0px_#EAEAEA,_-10px_-10px_16px_0px_#FFF]">
    <div className="py-1 max-h-[7.5rem] overflow-y-auto"> {/* Adjusted max-height to show only 3 items */}
      {fileList.map((file, index) => (
        <div
          key={index}
          onClick={() => {
            setSelectedFile(file); // Update selectedFile state
            setS3File(file); // Update s3File state (if needed)
            setShowFileDropdown(false); // Close the dropdown
          }}
          className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 cursor-pointer transition-colors duration-200"
        >
          {file
            .replace(/_/g, ' ') // Replace underscores with spaces
            .replace(/\d{8}T\d{6}Z/, '') // Remove date-time part
            .replace(/\.[^/.]+$/, '')} {/* Remove file extension */}
        </div>
      ))}
    </div>
  </div>
)}
          </div>
        )}
  
        {/* Toggle Switch - Always on the Right Side */}
        <div className="flex items-center relative group">
          <label className="inline-flex items-center cursor-pointer">
            <input 
              type="checkbox" 
              className="sr-only peer" 
              checked={isSearchUploadedFiles} 
              onChange={(e) => {
                e.stopPropagation();
                toggleSearchUploadedFiles();
              }}
            />
            <div className="w-11 h-6 bg-gray-300 rounded-full peer peer-checked:bg-[#EBAE12] relative after:absolute after:top-1 after:left-1 after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-5"></div>
          </label>
          <span className="absolute left-auto right-0 top-8 bg-black text-white text-xs rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
            Turn on Donor Compare List
          </span>
        </div>
      </div>
    </div>
  );
  };
  
  export default PromptBar;